module.exports = __webpack_public_path__ + "static/media/home-decor-1.decbdadf.jpeg";